module.exports = __webpack_public_path__ + "static/media/gasoline.ba6e5965.svg";